import { render, staticRenderFns } from "./articleBox.vue?vue&type=template&id=dc039a80&scoped=true&"
import script from "./articleBox.vue?vue&type=script&lang=js&"
export * from "./articleBox.vue?vue&type=script&lang=js&"
import style0 from "./articleBox.vue?vue&type=style&index=0&id=dc039a80&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc039a80",
  null
  
)

export default component.exports